export default class InitDocuments {
	constructor() {
		this.documents = [];
	}
}
